export const Mobile = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="9" y="5" width="14" height="24" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M9 9H23" stroke="currentColor" stroke-width="2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 25.5C14.5 24.6716 15.1682 24 15.9925 24H16.0075C16.8318 24 17.5 24.6716 17.5 25.5C17.5 26.3284 16.8318 27 16.0075 27H15.9925C15.1682 27 14.5 26.3284 14.5 25.5Z" fill="currentColor"/>
</svg>`;
